import { IEntityInfo, NSARouterMakerProps, NSALayout, NSASectionEditProps, NSASectionListProps, NSASectionViewProps } from "namirasoft-account-react";
import { IHeaderProps, NSBarActionProps, NSBarTitleProps } from "namirasoft-site-react";
import { Component, ReactNode } from "react";

export interface INSELayoutProps<EntityType extends { id: string }, EntityTypeInput = EntityType> extends NSARouterMakerProps
{
	header?: IHeaderProps;
	action?: NSBarActionProps;
	title?: NSBarTitleProps;
	pages?: {
		entity: IEntityInfo<EntityType, EntityTypeInput>;
		ui?: {
			action?: {
				menus: {
					new?: boolean;
					view?: boolean;
					viewHistory?: boolean;
					copy?: boolean;
					edit?: boolean;
					delete?: boolean;
					apply?: boolean;
				};
			};
		};
		list?: NSASectionListProps<EntityType>;
		edit?: NSASectionEditProps<EntityType, EntityTypeInput>;
		view?: NSASectionViewProps<EntityType>;
	};
	children: ReactNode;
}

export default class EmailSenderLayout<EntityType extends { id: string } = any, EntityTypeInput = EntityType> extends Component<INSELayoutProps<EntityType, EntityTypeInput>>
{
	override render()
	{
		return (
			<NSALayout
				scope='Namirasoft Email Sender Console'
				logo='https://static.namirasoft.com/image/namirasoft/email-sender/logo/base.png'
				background={{ image: "https://static.namirasoft.com/image/namirasoft/email-sender/background/base.webp" }}
				notifications={this.props.notifier.getNotifications()}
				action={this.props.action}
				title={this.props.title}
				pages={this.props.pages}
				account={this.props.account}
				url={this.props.url}
				notifier={this.props.notifier}
			>
				{this.props.children}
			</NSALayout >
		);
	}
}